var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFwcLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 219.8 53.8",
    style: {
      enableBackground: "new 0 0 219.8 53.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:none;stroke:#000000;stroke-width:2.5;stroke-miterlimit:10;}\n\t.st1{fill:#00416A;}\n\t.st2{fill:#0071CE;}\n\t.st3{fill:#369040;}\n\t.st4{display:none;}\n\t.st5{display:inline;}\n\t.st6{clip-path:url(#SVGID_2_);fill:#5987B5;}\n\t.st7{clip-path:url(#SVGID_2_);fill:#0071CE;}\n\t.st8{clip-path:url(#SVGID_2_);fill:#00416A;}\n\t.st9{clip-path:url(#SVGID_2_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sketch"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.8,25.8h20v4.3H30.5v7.3H44v4.3H30.5v10.9h-4.7V25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.6,25.8h5.1l6.4,19.9l6.6-20h4l6.6,20l6.4-19.9h4.9l-9.3,27h-4.1l-6.6-19.3L64,52.8H60L50.6,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,39.3L102.7,39.3c0-7.7,5.7-13.9,13.8-13.9c4.9,0,7.9,1.7,10.5,4.2l-3,3.5c-2.1-2-4.4-3.3-7.5-3.3 c-5.1,0-8.9,4.2-8.9,9.5v0.1c0,5.2,3.7,9.5,8.9,9.5c3.3,0,5.4-1.3,7.7-3.5l3,3.1c-2.8,2.9-5.9,4.8-10.9,4.8 C108.6,53.1,102.7,47,102.7,39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130,39.3L130,39.3c0-7.6,5.8-13.9,14.1-13.9s14,6.2,14,13.8v0.1c0,7.5-5.8,13.9-14.1,13.9S130,46.9,130,39.3 z M153.2,39.3L153.2,39.3c0-5.3-3.8-9.6-9.1-9.6s-9,4.3-9,9.5v0.1c0,5.2,3.8,9.5,9.1,9.5S153.2,44.5,153.2,39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.4,39.3L162.4,39.3c0-7.6,5.8-13.9,14.1-13.9s14,6.2,14,13.8v0.1c0,7.5-5.8,13.9-14.1,13.9 S162.4,46.9,162.4,39.3z M185.6,39.3L185.6,39.3c0-5.3-3.8-9.6-9.1-9.6s-9,4.3-9,9.5v0.1c0,5.2,3.8,9.5,9.1,9.5 C181.8,48.8,185.6,44.5,185.6,39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.5,25.8h4.7v13.5L213,25.8h5.8l-11.1,11.5l11.6,15.3h-5.7l-9.2-12.1l-4.2,4.3v7.8h-4.7V25.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "0.7,0.7 0.7,34.3 10.2,24.8 10.2,0.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21.2,13.8 13.7,13.8 13.7,21.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "13.7,0.7 13.7,10.2 24.7,10.2 34.2,0.7  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFwcLogo);
export default __webpack_public_path__ + "static/media/FWC-Logo.66664360e81ec125497f39b9ff71aaa4.svg";
export { ForwardRef as ReactComponent };